import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=9e2efe8a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=9e2efe8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2efe8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e2efe8a')) {
      api.createRecord('9e2efe8a', component.options)
    } else {
      api.reload('9e2efe8a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=9e2efe8a&scoped=true&", function () {
      api.rerender('9e2efe8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xXrqMrAPeEQi/JS/comp/GuestBox.vue"
export default component.exports